<div class="row mt-4 mb-3 ms-3" *ngIf="hasPermission(PERMISSION.USER_MANAGEMENT_CREATE_USER)">
  <div class="col-3">
    <button class="btn btn-outline-primary" (click)="openCreateModal()">
      <i class="fa fa-lg fa-plus me-1"></i>
      Create user
    </button>
  </div>
</div>
<ngx-datatable
  #datatableComponent
  class="material"
  style="height: calc(100vh - 180px)"
  [rows]="users"
  [columns]="columns"
  [messages]="{emptyMessage: 'Click to submit to filter', totalMessage: 'Total', selectedMessage: 'Selected'}"
  [columnMode]="ColumnMode.force"
  [headerHeight]="50"
  [footerHeight]="50"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [rowHeight]="50">
</ngx-datatable>


<ng-template #emailTmpl let-column="column">{{ column.name }}</ng-template>
<ng-template #updateRolesTmpl let-column="column">
  Update roles
</ng-template>
<ng-template #updateApplicationAccessesTmpl let-column="column">
  Update application accesses
</ng-template>
<ng-template #deleteUserTmpl let-column="column">
  Delete user
</ng-template>
<ng-template #enableUserTmpl let-column="column">
  Enable user
</ng-template>
<ng-template #updateUserAttributesTmpl let-column="column">
  Update user attributes
</ng-template>
<ng-template #changePasswordTmpl let-column="column">
  Change password
</ng-template>

<ng-template #emailCellTmpl let-row="row" let-value="value">{{value}}</ng-template>
<ng-template #updateRolesCellTmpl let-row="row" let-value="value">
  <div class="d-flex justify-content-end pe-4">
    <i class="fa fa-lg fa-user-edit cursor-pointer" (click)="openUpdateModal(row)"></i>
  </div>
</ng-template>
<ng-template #updateUserAttributesCellTmpl let-row="row" let-value="value">
  <div class="d-flex justify-content-end pe-4">
    <i class="fa fa-lg fa-user-edit cursor-pointer" (click)="openUpdateUserAttributes(row)"></i>
  </div>
</ng-template>
<ng-template #updateApplicationAccessesCellTmpl let-row="row" let-value="value">
  <div class="d-flex justify-content-end pe-4">
    <i class="fa fa-lg fa-user-edit cursor-pointer" (click)="openUpdateApplicationAccessesModal(row)"></i>
  </div>
</ng-template>
<ng-template #deleteUserCellTmpl let-row="row" let-value="value">
  <div class="d-flex justify-content-end pe-4">
    <i class="fa fa-lg fa-remove cursor-pointer" (click)="deleteUser(row)"></i>
  </div>
</ng-template>
<ng-template #changePasswordCellTmpl let-row="row" let-value="value">
  <div class="d-flex justify-content-end pe-4">
    <i class="fa fa-lg fa-user-edit cursor-pointer" (click)="openChangePasswordModal(row)"></i>
  </div>
</ng-template>
<!--<ng-template #enableUserCellTmpl let-row="row" let-value="value">-->
<!--  <div class="d-flex justify-content-end pe-4">-->
<!--    <i class="fa fa-lg fa-user-edit cursor-pointer" (click)="enableUser(row)"></i>-->
<!--  </div>-->
<!--</ng-template>-->
